import {useEffect, useState} from 'react';
import {getAllowedRegion} from '../../../service/UserService';
import {loadSettings, read} from '../../../service/AutoAssignService';
import {isAdminSession} from '../../../service/sessionRole';

export default function useAutoAssignAvailability() {
    const [regions, setRegions] = useState([]);
    useEffect(() => {
        let active = true;
        if (!isAdminSession()) return undefined;
        getAllowedRegion().then(read).then(async values => {
            const results = await Promise.allSettled(values.map(region => loadSettings(region)));
            if (active) setRegions(values.filter((_, i) => results[i].status === 'fulfilled'));
        }).catch(() => { if (active) setRegions([]); });
        return () => { active = false; };
    }, []);
    return regions;
}
